import { get, post } from '@/common/request';

/**
 * 获取账号中心自定义字段
 * https://yapi.lanhanba.com/mock/289/api/businessCircle/list
 */
export function getConfigCustomField(params?: any) {
  return get('/account/config/findCustomField', { ...params }, { proxyApi: '/mirage', needHint: true });
}

/**
 * 保存账号中心自定义字段
 * https://yapi.lanhanba.com/project/378/interface/api/45079
 */
export function postConfigCustomField(params?: any) {
  return post('/account/config/customField', { ...params }, { proxyApi: '/mirage', needHint: true });
};

/**
 * 行政区域
 * http://yapi.lanhanba.com/project/289/interface/api/33054
 */

export async function areaList(params?: any) {
  return get('/area/list', { ...params }, { proxyApi: '/mirage', needHint: true, needCancel: false, });
}

/**
 * 带enname的城市列表
 * https://yapi.lanhanba.com/project/378/interface/api/35468
 */
export function getCityList(params?: any) {
  return get(
    '/area/cityList',
    { ...params },
    {
      proxyApi: '/mirage',
      needHint: true,
      needCancel: false,
    },
  );
}

/**
 * 获取租户在资源服务的配置
 * https://yapi.lanhanba.com/project/319/interface/api/72498
 */

export async function getResourceConfig(params?: any) {
  return post('/property/company/optionConfig', { ...params }, { needHint: true });
}

/**
 * oss上传 预签名
 * https://yapi.lanhanba.com/project/297/interface/api/90253
 */
export function signFile(params?: any) {
  return post(`/oss/preSign`, params, {
    proxyApi: '/terra-api',
    needHint: true,
    needCancel: false
  });
}

